import { ScheduleTourApi } from 'services/Api/schedule/ScheduleTourApi';
import { IGetServiceDetailsByServiceIdResponse } from '../../_domain/dto/ReservePlaceSchedule/IGetServiceDetailsByServiceIdResponse';

export const GetServiceDetailsByServiceIdUseCase = async (serviceId: string): Promise<IGetServiceDetailsByServiceIdResponse> => {

    const scheduleTourApi = ScheduleTourApi();
    const response = await scheduleTourApi.getServiceDetailsByServiceId(serviceId);
    return response;
}
